import { Injectable } from '@angular/core';
import { BrandSocialMediaCode } from '@web/shared/module/brand';
import { SvgIcon } from '@web/shared/ui';
import { Observable, of } from 'rxjs';
import { isNil } from '@web/utils';
import { EntryNotFoundException } from '@web/common';

@Injectable({
  providedIn: 'root',
})
export class BrandSocialMediaIconProviderService {
  private readonly entries = new Map<BrandSocialMediaCode, SvgIcon>([
    [BrandSocialMediaCode.Facebook, SvgIcon.Facebook],
    [BrandSocialMediaCode.Instagram, SvgIcon.Instagram],
    [BrandSocialMediaCode.TikTok, SvgIcon.TikTok],
  ]);

  public icon(code: BrandSocialMediaCode): Observable<SvgIcon> {
    const entry = this.entries.get(code);

    if (isNil(entry)) {
      throw new EntryNotFoundException(
        `The icon entry for "${code}" code is not found.`,
      );
    }

    return of(entry);
  }
}
